import React, { useEffect, useRef } from 'react'
import { Row, Col } from 'react-bootstrap'
import { isMobile } from '../../helpers/index'
import { wallClockOf } from './flightNervePure'
import { displayTerminal } from 'helpers/terminalDisplay'
const FlightTrackingCard = ({
  getCity,
  departureTime,
  arrivalTime,
  delayDepartureTime,
  airportPickUpInfo,
  airportDropOffInfo,
  flightInfo,
  flightTotalDuration,
  progressPercentage,
  delayArrivalTime,
  noData,
  time,
  flightDataLoading,
  index,
  numberOfFlights,
}) => {
  const isMobileBrowser = isMobile()
  // A booking's date (airportPickUpInfo.date / airportDropOffInfo.date) may stand in for the
  // flight's own date ONLY on the same calendar day, or when the flight has no date.
  // Pinning it unconditionally invented flights: 5625-V (pick-up 20 Oct, AC866) showed
  // "YUL 19 Oct 18:40 → LHR 20 Oct 06:30", but AC866 does not fly on 19 Oct — the flight
  // found was the 20 Oct one landing on the 21st, re-labelled with the pick-up date.
  const sameCalendarDay = (a, b) => {
    const x = wallClockOf(a)
    const y = wallClockOf(b)
    return Boolean(x && y && x.day === y.day)
  }
  const bookedDateIfSameDay = (bookedValue, flightValue) => {
    if (!flightValue) return bookedValue || null
    if (!bookedValue) return flightValue
    return sameCalendarDay(bookedValue, flightValue) ? bookedValue : flightValue
  }
  const arrivalDateValue = bookedDateIfSameDay(
    airportPickUpInfo?.date,
    time?.arrival
  )
  // The departure leg's own `time.departure` DATE can be stale when the pickup date is
  // changed (it is fetched/cached separately). To keep the two legs consistent we anchor the
  // departure DATE to the arrival date and only apply the genuine whole-day offset between
  // the flight's scheduled departure and arrival (same fetch, so internally consistent).
  // Time-of-day is rendered separately and is unaffected.
  const getDepartureDateValue = () => {
    // Drop-off transfers carry their own departure date — trusted on the same terms.
    if (airportDropOffInfo?.date) {
      return bookedDateIfSameDay(airportDropOffInfo.date, time?.departure)
    }
    if (arrivalDateValue && time?.arrival && time?.departure) {
      const arr = new Date(time.arrival)
      const dep = new Date(time.departure)
      const anchor = new Date(arrivalDateValue)
      if (!isNaN(arr) && !isNaN(dep) && !isNaN(anchor)) {
        const arrDay = Date.UTC(
          arr.getUTCFullYear(),
          arr.getUTCMonth(),
          arr.getUTCDate()
        )
        const depDay = Date.UTC(
          dep.getUTCFullYear(),
          dep.getUTCMonth(),
          dep.getUTCDate()
        )
        const dayDiff = Math.round((arrDay - depDay) / 86400000)
        if (dayDiff !== 0) {
          anchor.setUTCDate(anchor.getUTCDate() - dayDiff)
        }
        return anchor.toISOString()
      }
    }
    return time?.departure
  }
  const departureDateValue = getDepartureDateValue()
  // Each card instance owns its progress bar via a ref. The old version used
  // a duplicated id='progressBar' + getElementById, which always targeted the
  // FIRST bar in the document — wrong whenever more than one card was mounted.
  const progressBarRef = useRef(null)
  useEffect(() => {
    const progressWidth = progressBarRef.current

    if (progressWidth) {
      if (progressPercentage >= 100) {
        progressWidth.style.width = 100 + '%'
      } else if (progressPercentage === 0 || progressPercentage < 0) {
        progressWidth.style.width = progressPercentage + 1 + '%'
      } else if (progressPercentage > 0 && progressPercentage < 100) {
        progressWidth.style.width = progressPercentage + '%'
      }
    }
  }, [progressPercentage])

  return (
    <>
      {isMobileBrowser ? (
        <>
          {/* Mobile */}
          {!flightDataLoading && !noData ? (
            <div
              className={`flightTracking-info   ${
                index === numberOfFlights - 1 ? 'flight-border-bottom' : ''
              }`}
            >
              <>
                {flightInfo && flightInfo.airline ? (
                  <div className='flightTitle'>{`${
                    flightInfo.airline.name ? flightInfo.airline.name : ''
                  } ${flightInfo.airline.iata} ${
                    flightInfo.airline.number
                  }`}</div>
                ) : (
                  ''
                )}
                {getCity && getCity.arrivalInfo && getCity.departureInfo ? (
                  <div className='flightSubTitle'>{`${getCity.departureInfo.city} to ${getCity.arrivalInfo.city}`}</div>
                ) : (
                  ''
                )}
                {delayDepartureTime &&
                flightInfo &&
                (flightInfo.flight_status === 'Scheduled' ||
                  flightInfo.flight_status === 'Delayed' ||
                  flightInfo.flight_status === 'scheduled') ? (
                  <div className='flightStatus-delayed'>{`DEPARTING ${delayDepartureTime} MINUTES LATE`}</div>
                ) : (
                  <>
                    {delayArrivalTime &&
                    flightInfo &&
                    flightInfo.flight_status === 'In Air' ? (
                      <div className='flightStatus-delayed'>{`ARRIVING ${delayArrivalTime} MINUTES LATE`}</div>
                    ) : (
                      <>
                        {flightInfo &&
                        flightInfo.flight_status === 'Arrived' ? (
                          <div className='flightStatus-onTime'>ARRIVED</div>
                        ) : flightInfo.flight_status === 'Delayed' ? (
                          <div className='flightStatus-delayed'>Delayed</div>
                        ) : (
                          <div className='flightStatus-onTime'>ON TIME</div>
                        )}
                      </>
                    )}
                  </>
                )}
                {/* Flight IATA Departure Mobile */}
                <Row noGutters className='mb-2'>
                  {flightInfo && flightInfo.departure.iata ? (
                    <Col
                      // md={1}
                      className='flight-iata-departure d-flex justify-content-start mr-1 col-1'
                    >
                      {`${flightInfo.departure.iata}`}
                    </Col>
                  ) : (
                    ''
                  )}
                  {/* progressBar */}
                  {progressPercentage && (
                    <>
                      {delayArrivalTime &&
                      flightInfo &&
                      flightInfo.flight_status === 'In Air' ? (
                        // progressBar with delay (Red) Mobile
                        <Col
                          md={6}
                          className='d-flex justify-content-center align-items-center mb-1 px-1 time-bar col-6'
                          style={
                            flightInfo &&
                            (flightInfo.flight_status === 'In Air' ||
                              flightInfo.flight_status === 'Delayed')
                              ? {
                                  maxWidth: '68%',
                                  marginTop: '0.7rem',
                                }
                              : { maxWidth: '68%' }
                          }
                        >
                          {flightInfo &&
                            (flightInfo.flight_status === 'scheduled' ||
                              flightInfo.flight_status === 'Scheduled' ||
                              flightInfo.flight_status === 'Arrived') && (
                              <span className='progress-time'>
                                {flightTotalDuration ? flightTotalDuration : ''}
                              </span>
                            )}
                          <div className='myProgress'>
                            <div
                              ref={progressBarRef}
                              className={'plane-position myBar-red'}
                            >
                              <img
                                alt=''
                                src='/images/planeIcons/plane_red_withBorder.png'
                                className='plane-size'
                              ></img>
                            </div>
                          </div>
                        </Col>
                      ) : (
                        // progressBar with no delay (Green) Mobile
                        <Col
                          className='d-flex justify-content-center align-items-center mb-1 px-1 time-bar col-6'
                          style={
                            flightInfo &&
                            (flightInfo.flight_status === 'In Air' ||
                              flightInfo.flight_status === 'Delayed')
                              ? {
                                  maxWidth: '68%',
                                  marginTop: '0.7rem',
                                }
                              : { maxWidth: '68%' }
                          }
                        >
                          {flightInfo &&
                            (flightInfo.flight_status === 'scheduled' ||
                              flightInfo.flight_status === 'Scheduled' ||
                              flightInfo.flight_status === 'Arrived') && (
                              <span className='progress-time'>
                                {flightTotalDuration ? flightTotalDuration : ''}
                              </span>
                            )}
                          <div className='myProgress'>
                            <div
                              ref={progressBarRef}
                              className={'plane-position myBar-green'}
                            >
                              <img
                                alt=''
                                src='/images/planeIcons/plane_dark_green_withBorder.png'
                                className='plane-size'
                              ></img>
                            </div>
                          </div>
                        </Col>
                      )}
                    </>
                  )}
                  {/* Flight IATA Arrival Mobile */}
                  {flightInfo && flightInfo.arrival.iata ? (
                    <Col
                      // md={1}
                      className='flight-iata-arrival d-flex ml-2 col-1 mr-2'
                    >
                      {`${flightInfo.arrival.iata}`}
                    </Col>
                  ) : (
                    ''
                  )}
                </Row>
                <div className='flight-align-row'>
                  {/* Departure section info Mobile*/}
                  <Row noGutters className='mb-4'>
                    <Col className='d-flex flex-column'>
                      {getCity?.departureInfo && departureDateValue
                        ? (() => {
                            const dateValue = departureDateValue
                            const dateObj = new Date(dateValue)
                            return (
                              <span className='flightSubTitle'>
                                {getCity.departureInfo.city}{' '}
                                <span className='dot-size'>•</span>{' '}
                                {`${dateObj.toLocaleString('en-US', {
                                  weekday: 'short',
                                  timeZone: 'UTC',
                                })} ${dateObj.getUTCDate()} ${dateObj.toLocaleString(
                                  'en-US',
                                  {
                                    month: 'short',
                                    timeZone: 'UTC',
                                  }
                                )} ${dateObj.getUTCFullYear()}`}
                              </span>
                            )
                          })()
                        : ''}
                      {progressPercentage === 0 ||
                      (flightInfo &&
                        (flightInfo.flight_status === 'Delayed' ||
                          flightInfo.flight_status === 'Scheduled' ||
                          flightInfo.flight_status === 'scheduled')) ? (
                        <>
                          {delayDepartureTime ? (
                            <span className='flight-inner-title'>
                              ESTIMATED DEPARTURE
                            </span>
                          ) : (
                            <span className='flight-inner-title'>
                              SCHEDULED DEPARTURE
                            </span>
                          )}
                        </>
                      ) : (
                        <span className='flight-inner-title'>DEPARTED</span>
                      )}
                      {departureTime && departureTime.time ? (
                        <span
                          className={
                            delayDepartureTime &&
                            flightInfo &&
                            (flightInfo.flight_status === 'Delayed' ||
                              flightInfo.flight_status === 'Scheduled' ||
                              flightInfo.flight_status === 'scheduled')
                              ? 'flight-time-red'
                              : 'flight-time-green'
                          }
                        >
                          {`${departureTime.time.hours}:${departureTime.time.scheduleMinutes}`}
                        </span>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col className='d-flex flex-column'>
                      {/* Departure terminal/gate Mobile*/}
                      <div className='d-flex align-items-baseline'>
                        <div className='d-flex flex-column'>
                          <span className='terminal-gate-title'>TERMINAL</span>
                          {(airportDropOffInfo &&
                            airportDropOffInfo.terminal) ||
                          flightInfo?.departure?.terminal ? (
                            <span className='terminal-gate-num'>{`${(airportDropOffInfo &&
                              airportDropOffInfo.terminal) ||
                              displayTerminal(
                                flightInfo.departure.terminal
                              )}`}</span>
                          ) : (
                            <span className='terminal-gate-num'>-</span>
                          )}
                        </div>
                        <div className='d-flex flex-column flight-gate'>
                          <span className='terminal-gate-title'>GATE</span>
                          {flightInfo &&
                          flightInfo.departure.gate &&
                          flightInfo.departure.gate !== 'null' ? (
                            <span className='terminal-gate-num'>{`${flightInfo.departure.gate}`}</span>
                          ) : (
                            <span className='terminal-gate-num'>-</span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {/* Arrival section info Mobile*/}
                  <Row noGutters>
                    <Col className='d-flex flex-column'>
                      {getCity?.arrivalInfo && arrivalDateValue
                        ? (() => {
                            const dateObj = new Date(arrivalDateValue)

                            return (
                              <span className='flightSubTitle'>
                                {getCity.arrivalInfo.city}{' '}
                                <span className='dot-size'>•</span>{' '}
                                {`${dateObj.toLocaleString('en-US', {
                                  weekday: 'short',
                                  timeZone: 'UTC',
                                })} ${dateObj.getUTCDate()} ${dateObj.toLocaleString(
                                  'en-US',
                                  {
                                    month: 'short',
                                    timeZone: 'UTC',
                                  }
                                )} ${dateObj.getUTCFullYear()}`}
                              </span>
                            )
                          })()
                        : ''}
                      {progressPercentage >= 100 ||
                      (flightInfo && flightInfo.flight_status === 'Arrived') ? (
                        <span className='flight-inner-title'>ARRIVED</span>
                      ) : (
                        <span className='flight-inner-title'>
                          ESTIMATED ARRIVAL
                        </span>
                      )}
                      {arrivalTime && arrivalTime.time ? (
                        <span
                          className={
                            delayArrivalTime &&
                            flightInfo &&
                            flightInfo.flight_status === 'In Air'
                              ? 'flight-time-red'
                              : 'flight-time-green'
                          }
                        >{`${arrivalTime.time.hours}:${arrivalTime.time.scheduleMinutes}`}</span>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col className='d-flex flex-column'>
                      {/* Arrival terminal/gate Mobile*/}
                      <div className='d-flex align-items-baseline'>
                        <div className='d-flex flex-column'>
                          <span className='terminal-gate-title'>TERMINAL</span>
                          {(airportPickUpInfo && airportPickUpInfo.terminal) ||
                          flightInfo?.arrival?.terminal ? (
                            <span className='terminal-gate-num'>{`${(airportPickUpInfo &&
                              airportPickUpInfo.terminal) ||
                              displayTerminal(
                                flightInfo.arrival.terminal
                              )}`}</span>
                          ) : (
                            <span className='terminal-gate-num'>-</span>
                          )}
                        </div>
                        <div className='d-flex flex-column flight-gate'>
                          <span className='terminal-gate-title'>GATE</span>
                          {flightInfo &&
                          flightInfo.arrival.gate &&
                          flightInfo.arrival.gate !== 'null' ? (
                            <span className='terminal-gate-num'>{`${flightInfo.arrival.gate}`}</span>
                          ) : (
                            <span className='terminal-gate-num'>-</span>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>{' '}
              </>
            </div>
          ) : (
            ''
          )}
        </>
      ) : (
        <>
          {/* Desktop View */}
          {!flightDataLoading && !noData ? (
            <div
              className={`flightTracking-info  ${
                index === numberOfFlights - 1 ? 'flight-border-bottom' : ''
              }`}
            >
              <>
                {flightInfo && flightInfo.airline ? (
                  <div className='flightTitle'>{`${
                    flightInfo.airline.name ? flightInfo.airline.name : ''
                  } ${flightInfo.airline.iata} ${
                    flightInfo.airline.number
                  }`}</div>
                ) : (
                  ''
                )}
                {getCity && getCity.arrivalInfo && getCity.departureInfo ? (
                  <div className='flightCityName'>{`${getCity.departureInfo.city} to ${getCity.arrivalInfo.city}`}</div>
                ) : (
                  ''
                )}
                {delayDepartureTime &&
                flightInfo &&
                (flightInfo.flight_status === 'Scheduled' ||
                  flightInfo.flight_status === 'scheduled') ? (
                  <div className='flightStatus-delayed'>{`DEPARTING ${delayDepartureTime} MINUTES LATE`}</div>
                ) : (
                  <>
                    {delayArrivalTime &&
                    flightInfo &&
                    flightInfo.flight_status === 'In Air' ? (
                      <div className='flightStatus-delayed'>{`ARRIVING ${delayArrivalTime} MINUTES LATE`}</div>
                    ) : (
                      <>
                        {flightInfo &&
                        flightInfo.flight_status === 'Arrived' ? (
                          <div className='flightStatus-onTime'>ARRIVED</div>
                        ) : (
                          <>
                            {flightInfo &&
                            (flightInfo.flight_status === 'scheduled' ||
                              flightInfo.flight_status === 'Scheduled') ? (
                              <div className='flightStatus-onTime'>
                                SCHEDULED
                              </div>
                            ) : flightInfo.flight_status === 'Delayed' ? (
                              <div className='flightStatus-delayed'>
                                Delayed
                              </div>
                            ) : (
                              <div className='flightStatus-onTime'>ON TIME</div>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
                <Row noGutters className='mb-2'>
                  {flightInfo && flightInfo.departure.iata ? (
                    <Col
                      md={1}
                      className='flight-iata-departure d-flex justify-content-start'
                    >
                      {`${flightInfo.departure.iata}`}
                    </Col>
                  ) : (
                    ''
                  )}
                  {/* progressBar */}
                  {progressPercentage && (
                    <>
                      {delayArrivalTime &&
                      flightInfo &&
                      flightInfo.flight_status === 'In Air' ? (
                        // progressBar with delay (Red)
                        <Col
                          md={7}
                          className={
                            flightInfo &&
                            (flightInfo.flight_status === 'In Air' ||
                              flightInfo.flight_status === 'Delayed')
                              ? 'd-flex justify-content-center align-items-center mb-1 px-1 time-bar margin-top'
                              : 'd-flex justify-content-center align-items-center mb-1 px-1 time-bar'
                          }
                        >
                          {flightInfo &&
                            (flightInfo.flight_status === 'scheduled' ||
                              flightInfo.flight_status === 'Scheduled' ||
                              flightInfo.flight_status === 'Arrived') && (
                              <span className='progress-time'>
                                {flightTotalDuration ? flightTotalDuration : ''}
                              </span>
                            )}
                          <div className='myProgress'>
                            <div
                              ref={progressBarRef}
                              className={'plane-position myBar-red'}
                            >
                              <img
                                alt=''
                                src='/images/planeIcons/plane_red_withBorder.png'
                                className='plane-size'
                              ></img>
                            </div>
                          </div>
                        </Col>
                      ) : (
                        // progressBar with no delay (Green)
                        <Col
                          md={7}
                          className={
                            flightInfo &&
                            (flightInfo.flight_status === 'In Air' ||
                              flightInfo.flight_status === 'Delayed')
                              ? 'd-flex justify-content-center align-items-center mb-1 px-1 time-bar margin-top'
                              : 'd-flex justify-content-center align-items-center mb-1 px-1 time-bar'
                          }
                        >
                          {flightInfo &&
                            (flightInfo.flight_status === 'scheduled' ||
                              flightInfo.flight_status === 'Scheduled' ||
                              flightInfo.flight_status === 'Arrived') && (
                              <span className='progress-time'>
                                {flightTotalDuration ? flightTotalDuration : ''}
                              </span>
                            )}
                          <div className='myProgress'>
                            <div
                              ref={progressBarRef}
                              className={'plane-position myBar-green'}
                            >
                              <img
                                alt=''
                                src='/images/planeIcons/plane_dark_green_withBorder.png'
                                className='plane-size'
                              ></img>
                            </div>
                          </div>
                        </Col>
                      )}
                    </>
                  )}
                  {flightInfo && flightInfo.arrival.iata ? (
                    <Col md={1} className='flight-iata-arrival d-flex'>
                      {`${flightInfo.arrival.iata}`}
                    </Col>
                  ) : (
                    ''
                  )}
                </Row>
                <Row className='flight-align-row'>
                  {/* Departure section info */}
                  <Col className='d-flex flex-column flight-section-border'>
                    {getCity?.departureInfo && departureDateValue
                      ? (() => {
                          const dateValue = departureDateValue
                          const dateObj = new Date(dateValue)

                          return (
                            <span className='flightSubTitle'>
                              {getCity.departureInfo.city}{' '}
                              <span className='dot-size'>•</span>{' '}
                              {`${dateObj.toLocaleString('en-US', {
                                weekday: 'short',
                                timeZone: 'UTC',
                              })} ${dateObj.getUTCDate()} ${dateObj.toLocaleString(
                                'en-US',
                                {
                                  month: 'short',
                                  timeZone: 'UTC',
                                }
                              )} ${dateObj.getUTCFullYear()}`}
                            </span>
                          )
                        })()
                      : ''}
                    {progressPercentage === 0 ||
                    (flightInfo &&
                      (flightInfo.flight_status === 'Delayed' ||
                        flightInfo.flight_status === 'Scheduled' ||
                        flightInfo.flight_status === 'scheduled')) ? (
                      <>
                        {delayDepartureTime ? (
                          <span className='flight-inner-title mt-2'>
                            ESTIMATED DEPARTURE
                          </span>
                        ) : (
                          <span className='flight-inner-title mt-2'>
                            SCHEDULED DEPARTURE
                          </span>
                        )}
                      </>
                    ) : (
                      <span className='flight-inner-title mt-1'>DEPARTED</span>
                    )}
                    {departureTime && departureTime.time ? (
                      <span
                        className={
                          delayDepartureTime &&
                          flightInfo &&
                          (flightInfo.flight_status === 'Delayed' ||
                            flightInfo.flight_status === 'Scheduled' ||
                            flightInfo.flight_status === 'scheduled')
                            ? 'flight-time-red'
                            : 'flight-time-green'
                        }
                      >
                        {`${departureTime.time.hours}:${departureTime.time.scheduleMinutes}`}
                      </span>
                    ) : (
                      ''
                    )}
                    {/* Departure terminal/gate */}
                    <div className='d-flex align-items-baseline mt-1'>
                      <div className='d-flex flex-column'>
                        <span className='flight-inner-title'>TERMINAL</span>
                        {(airportDropOffInfo && airportDropOffInfo.terminal) ||
                        flightInfo?.departure?.terminal ? (
                          <span className='terminal-gate-num'>{`${(airportDropOffInfo &&
                            airportDropOffInfo.terminal) ||
                            displayTerminal(
                              flightInfo.departure.terminal
                            )}`}</span>
                        ) : (
                          <span className='terminal-gate-num'>-</span>
                        )}
                      </div>
                      <div className='d-flex flex-column flight-gate'>
                        <span className='flight-inner-title'>GATE</span>
                        {flightInfo &&
                        flightInfo.departure.gate &&
                        flightInfo.departure.gate !== 'null' ? (
                          <span className='terminal-gate-num'>{`${flightInfo.departure.gate}`}</span>
                        ) : (
                          <span className='terminal-gate-num'>-</span>
                        )}
                      </div>
                    </div>
                  </Col>
                  {/* Arrival section info */}
                  <Col className='d-flex flex-column flight-arrival-section'>
                    {getCity?.arrivalInfo && arrivalDateValue
                      ? (() => {
                          const dateObj = new Date(arrivalDateValue)

                          return (
                            <span className='flightSubTitle'>
                              {getCity.arrivalInfo.city}{' '}
                              <span className='dot-size'>•</span>{' '}
                              {`${dateObj.toLocaleString('en-US', {
                                weekday: 'short',
                                timeZone: 'UTC',
                              })} ${dateObj.getUTCDate()} ${dateObj.toLocaleString(
                                'en-US',
                                {
                                  month: 'short',
                                  timeZone: 'UTC',
                                }
                              )} ${dateObj.getUTCFullYear()}`}
                            </span>
                          )
                        })()
                      : ''}
                    {progressPercentage >= 100 ||
                    (flightInfo && flightInfo.flight_status === 'Arrived') ? (
                      <span className='flight-inner-title mt-1'>ARRIVED</span>
                    ) : (
                      <>
                        {delayArrivalTime &&
                        flightInfo &&
                        (flightInfo.flight_status === 'In Air' ||
                          flightInfo.flight_status === 'Delayed' ||
                          flightInfo.flight_status === 'Scheduled' ||
                          flightInfo.flight_status === 'scheduled') ? (
                          <span className='flight-inner-title mt-2'>
                            ESTIMATED ARRIVAL
                          </span>
                        ) : (
                          <span className='flight-inner-title mt-2'>
                            SCHEDULED ARRIVAL
                          </span>
                        )}
                      </>
                    )}
                    {arrivalTime && arrivalTime.time ? (
                      <span
                        className={
                          delayArrivalTime &&
                          flightInfo &&
                          (flightInfo.flight_status === 'In Air' ||
                            flightInfo.flight_status === 'Delayed' ||
                            flightInfo.flight_status === 'Scheduled' ||
                            flightInfo.flight_status === 'scheduled')
                            ? 'flight-time-red'
                            : 'flight-time-green'
                        }
                      >{`${arrivalTime.time.hours}:${arrivalTime.time.scheduleMinutes}`}</span>
                    ) : (
                      ''
                    )}
                    {/* Arrival terminal/gate */}
                    <div className='d-flex align-items-baseline mt-1'>
                      <div className='d-flex flex-column'>
                        <span className='flight-inner-title mt-1'>
                          TERMINAL
                        </span>
                        {(airportPickUpInfo && airportPickUpInfo.terminal) ||
                        flightInfo?.arrival?.terminal ? (
                          <span className='terminal-gate-num'>{`${(airportPickUpInfo &&
                            airportPickUpInfo.terminal) ||
                            displayTerminal(
                              flightInfo.arrival.terminal
                            )}`}</span>
                        ) : (
                          <span className='terminal-gate-num'>-</span>
                        )}
                      </div>
                      <div className='d-flex flex-column flight-gate'>
                        <span className='flight-inner-title mt-1'>GATE</span>
                        {flightInfo &&
                        flightInfo.arrival.gate &&
                        flightInfo.arrival.gate !== 'null' ? (
                          <span className='terminal-gate-num'>{`${flightInfo.arrival.gate}`}</span>
                        ) : (
                          <span className='terminal-gate-num'>-</span>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>{' '}
              </>
            </div>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}

export default FlightTrackingCard
